import axios from "axios";

export const axiosStrapiApi = () => {
    return axios.create({
        baseURL: process.env.REACT_APP_STRAPI_API_URL,
        headers: {}
    });
}
